export function classes(...classes: (string | false | null | undefined)[]) {
  return classes.filter(cls => typeof cls === 'string').join(' ');
}
